import React from 'react';
import ReactSpeedometer from "react-d3-speedometer";
import './gauge.css'

class Gauge extends React.Component {
  state = {
    windowHeight: undefined,
    windowWidth: undefined,
    firstLoad: true
  }

  handleResize = () => this.setState({
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth
  });

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize)
    setTimeout(() => {
      this.setState({ firstLoad: false })
    }, 1000);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  render() {
    let d = this.props.data
    let value = parseFloat(d.value).toFixed(2)
    return (
        <div className='gauge'>
          <ReactSpeedometer
            maxValue={parseFloat(d.maxValue) || 6}
            value={parseFloat(value)}
            startColor={d.startColor || 'red'}
            endColor={d.endColor || '#02FF01'}
            segmentColors={["red", "orange", "#02FF01"]}
            //   segments={Math.round(d.maxValue / 2)}
            segments={3}
            needleTransitionDuration={this.state.firstLoad ? 2000 : 0}
            needleTransition="easeBackOut"
            textColor={'var(--txt-color)'}
            needleColor={'var(--txt-color)'}
            needleHeightRatio={0.6}
            forceRender={true}
            fluidWidth={this.state.windowWidth > 767 ? true : false}
            width={this.state.windowWidth > 767 ? undefined : 300}
          />

        </div>
    )
  }
}

export default Gauge
